import { useEffect,useState } from "react";
import styles from "../styles/carousel.module.css";

const images = [
    "/assets/instalacion01.jpg",
    "/assets/instalacion02.jpg",
    "/assets/instalacion03.jpg",
    "/assets/instalacion04.jpg",
    "/assets/instalacion05.jpg"
];

export default function Carousel() {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev + 1) % images.length);
        }, 3000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className={styles.carousel}>
            <div className={styles.slide}>
                <img src={images[current]} alt={`slide-${current}`} />
            </div>

            <div className={styles.dots}>
                {images.map((_, index) => (
                    <span
                        key={index}
                        className={`${styles.dot} ${index === current ? styles.active : ""}`}
                    />
                ))}
            </div>
        </div>
    );
}